export default __webpack_public_path__ + "static/media/close-navbar.c54b6c7b.svg";